<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title bg-warning">
        <h1 class="text-bold text-white">Scan Order Number (FINISHED)</h1>
      </div>
      <div class="grid-body">
        <div class="row">
          <form @submit.prevent="submit()">
            <div class="col-md-12">
              <input
                type="text"
                v-model="shirtOrderId"
                :placeholder="message"
                class="form-control scan-shirt"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      shirtOrderId: null,
      message: "Order Number",
    };
  },
  mounted() {
    $(".scan-shirt").focus();
  },
  methods: {
    async submit() {
      if (!this.shirtOrderId) {
        return false;
      }
      try {
        let res = await axios.post("shirt_orders/repair/finished", {
          shirtOrderId: this.shirtOrderId,
        });
        if (res) {
          toastr.success("Success");
          this.message = this.shirtOrderId;
          this.shirtOrderId = null;
        }
      } catch (error) {
        $(".loading").hide();
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          let message = error.response.data.message;
          Swal.fire(message, "", "error");
        }
      }
    },
  },
};
</script>

<style scoped>
.scan-shirt {
  font-size: 90px !important;
  height: 200px;
}
.btn-lg {
  height: 50px;
  font-size: 25px;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}
.message {
  font-size: 90px;
}
.x-3 {
  margin-right: 3px;
  margin-bottom: 3px;
  color: black;
}
.box-number {
  margin-top: 50px;
}
.box-number input {
  height: 53px;
  font-size: 20px;
}
.text-capitalize {
  text-transform: capitalize;
}

.pretty {
  margin-bottom: 13px;
  display: block !important;
}
.d-none {
  display: none;
}
</style>
